import { useEffect, useState } from 'react';
import { useAccount, useConnect } from 'wagmi';
import { FiSmartphone } from 'react-icons/fi';

/**
 * On Android/iOS, approving in MetaMask often leaves the user in the wallet app.
 * WalletConnect completes when they return to this browser tab — this banner explains that.
 */
export default function WalletMobileReturnHint() {
  const { isConnected } = useAccount();
  const { isPending, isSuccess } = useConnect();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (isPending) setDismissed(false);
  }, [isPending]);

  useEffect(() => {
    if (isConnected || isSuccess) setDismissed(false);
  }, [isConnected, isSuccess]);

  if (!isPending || dismissed) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[190] border-t border-cyan-500/30 px-4 py-3 shadow-[0_-8px_32px_rgba(0,0,0,0.45)] sm:py-4"
      style={{
        paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom, 0px))',
        background: 'linear-gradient(180deg, rgba(10, 14, 39, 0.97) 0%, rgba(3, 7, 18, 0.99) 100%)',
      }}
      role="status"
      aria-live="polite"
    >
      <div className="mx-auto flex max-w-lg flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div className="flex gap-3 min-w-0">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-cyan-500/15 ring-1 ring-cyan-500/35">
            <FiSmartphone className="h-5 w-5 text-cyan-400" aria-hidden />
          </div>
          <p className="text-sm leading-snug text-gray-200">
            <span className="font-semibold text-white">Return to this browser</span> after you approve in
            MetaMask. Use your app switcher (Recent apps), then tap your browser again — your connection
            finishes here automatically.
          </p>
        </div>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="shrink-0 rounded-lg border border-white/15 px-3 py-2 text-xs font-semibold text-gray-300 hover:bg-white/5 sm:text-sm"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
